module.exports = __webpack_public_path__ + "static/wpack/extracted/link-icona46e37075eafa8202dadc76747b58ce0.svg";